export const bet365 = {
    rules: 'https://help.bet365.com/en/rules',
    termsAndConditions: 'https://help.bet365.com/en/terms-and-conditions',
};

export const coral = {
    termsAndConditions: 'https://coral-eng.custhelp.com/app/answers/detail/a_id/2130',
    responsibleGambling: 'http://responsiblegambling.coral.co.uk/',
    licenseUK: 'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/39071',
    licenseGI: 'https://www.gibraltar.gov.gi/new/remote-gambling',
    tscs: 'https://help.coral.co.uk/en/general-information/'
    + 'legal-matters/terms-and-conditions',
    website: 'https://coral.co.uk',
    gamblingCommission: 'https://www.gamblingcommission.gov.uk/public-register/'
    + 'business/detail/54743',
    gibraltar: 'https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling',
};

export const williamhill = {
    rules: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2063',
    license: 'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/39225',
    responsibleGambling: 'https://williamhill-lang.custhelp.com/app/answers/'
    + 'detail/a_id/2733/kw/responsible%20gambling',
    underage: 'https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2960',
};

export const ladbrokes = {
    rules: 'http://helpcentre.ladbrokes.com/app/answers/detail/a_id/283',
    licenseUK: 'https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/1611',
    licenseGI: 'https://www.gibraltar.gov.gi/new/remote-gambling',
    underage: 'http://media.ladbrokes.com/generic/images/siteImages/footerIcons_various/18.gif',
    tscs: 'https://help.ladbrokes.com/en/general-information/'
    + 'legal-matters/terms-and-conditions',
    website: 'https://Ladbrokes.com',
    gamblingCommission: 'https://www.gamblingcommission.gov.uk/public-register/'
    + 'business/detail/54743',
    gibraltar: 'https://www.gibraltar.gov.gi/finance-gaming-and-regulations/remote-gambling',
};

export const paddypower = {
    mga: 'https://www.authorisation.mga.org.mt/verification.aspx?'
    + 'lang=en&company=4f2ce9bc-6584-440c-8643-9314defffd0e',
    gamCommission: 'http://www.gamblingcommission.gov.uk/',
    gamingAuthority: 'https://www.mga.org.mt/',
    license: 'https://www.paddypower.com/aboutUs/Regulatory.Information/',
    gamingCommission: 'https://secure.gamblingcommission.gov.uk/'
    + 'PublicRegister/Search/Detail/39439',
    terms: 'https://www.paddypower.com/en/aboutUs/Terms.and.Conditions/',
    responsibleGambling: 'http://responsiblegaming.paddypower.com/',
    underage: 'https://support.paddypower.com/app/answers/detail/a_id/70',
};

export const betfair = {
    mga: 'https://www.authorisation.mga.org.mt/verification.aspx?'
    + 'lang=en&company=4f2ce9bc-6584-440c-8643-9314defffd0e',
    gamCommission: 'http://www.gamblingcommission.gov.uk/',
    gamingAuthority: 'https://www.mga.org.mt/',
    license: 'https://www.betfair.com/aboutUs/Regulatory.Information/',
    gamingCommission: 'https://secure.gamblingcommission.gov.uk/'
    + 'PublicRegister/Search/Detail/39439',
    terms: 'https://www.betfair.com/en/aboutUs/Terms.and.Conditions/',
    responsibleGambling: 'http://responsiblegaming.betfair.com/',
    underage: 'http://content.betfair.com/misc/?product=portal&sWhichKey=gamCare&'
    + 'locale=en_GB&region=GBR&brand=betfair&entrydomain=betfair.com',
};

export const common = {
    gamaware: 'https://www.begambleaware.org/',
    gamcare: 'http://www.gamcare.org.uk/',
    gamtherapy: 'https://www.gamblingtherapy.org/',
    gamstop: 'https://www.gamstop.co.uk/',
    funstops: 'http://www.whenthefunstops.co.uk/',
    ibas: 'https://www.ibas-uk.com/',
    raig: 'https://www.raig.org/',
};



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/urlConstants.js